/* eslint-disable no-console */

const isProd = process.env.NODE_ENV === 'production'

export function devLog(...args) {
  if (!isProd) console.log(...args)
}

export function devWarn(...args) {
  if (!isProd) console.warn(...args)
}

export function devError(...args) {
  if (!isProd) console.error(...args)
}

